/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Manage_Cost_CentersInputs */

const en_admin_resource_form_manage_cost_centers = /** @type {(inputs: Admin_Resource_Form_Manage_Cost_CentersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage cost centers`)
};

const de_admin_resource_form_manage_cost_centers = /** @type {(inputs: Admin_Resource_Form_Manage_Cost_CentersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenstellen verwalten`)
};

const es_admin_resource_form_manage_cost_centers = /** @type {(inputs: Admin_Resource_Form_Manage_Cost_CentersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionar centros de costes`)
};

const fr_admin_resource_form_manage_cost_centers = /** @type {(inputs: Admin_Resource_Form_Manage_Cost_CentersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérer les centres de coûts`)
};

const nl_admin_resource_form_manage_cost_centers = /** @type {(inputs: Admin_Resource_Form_Manage_Cost_CentersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenplaatsen beheren`)
};

/** @type {(inputs: Admin_Resource_Form_Manage_Cost_CentersInputs) => LocalizedString} */
const it_admin_resource_form_manage_cost_centers = en_admin_resource_form_manage_cost_centers;

/** @type {(inputs: Admin_Resource_Form_Manage_Cost_CentersInputs) => LocalizedString} */
const pt_br2_admin_resource_form_manage_cost_centers = en_admin_resource_form_manage_cost_centers;

/** @type {(inputs: Admin_Resource_Form_Manage_Cost_CentersInputs) => LocalizedString} */
const pl_admin_resource_form_manage_cost_centers = en_admin_resource_form_manage_cost_centers;

/** @type {(inputs: Admin_Resource_Form_Manage_Cost_CentersInputs) => LocalizedString} */
const hu_admin_resource_form_manage_cost_centers = en_admin_resource_form_manage_cost_centers;

/** @type {(inputs: Admin_Resource_Form_Manage_Cost_CentersInputs) => LocalizedString} */
const ro_admin_resource_form_manage_cost_centers = en_admin_resource_form_manage_cost_centers;

/**
* | output |
* | --- |
* | "Manage cost centers" |
*
* @param {Admin_Resource_Form_Manage_Cost_CentersInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_manage_cost_centers = /** @type {((inputs?: Admin_Resource_Form_Manage_Cost_CentersInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Manage_Cost_CentersInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_manage_cost_centers(inputs)
	if (locale === "de") return de_admin_resource_form_manage_cost_centers(inputs)
	if (locale === "es") return es_admin_resource_form_manage_cost_centers(inputs)
	if (locale === "fr") return fr_admin_resource_form_manage_cost_centers(inputs)
	if (locale === "nl") return nl_admin_resource_form_manage_cost_centers(inputs)
	if (locale === "it") return it_admin_resource_form_manage_cost_centers(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_manage_cost_centers(inputs)
	if (locale === "pl") return pl_admin_resource_form_manage_cost_centers(inputs)
	if (locale === "hu") return hu_admin_resource_form_manage_cost_centers(inputs)
	return ro_admin_resource_form_manage_cost_centers(inputs)
});
export { admin_resource_form_manage_cost_centers as "admin.resource_form.manage_cost_centers" }